"use strict";

var _regeneratorRuntime = require("/codebuild/output/src013157826/src/gardner/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime.js");

var _asyncToGenerator = require("/codebuild/output/src013157826/src/gardner/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.upload = void 0;

var uuid_1 = require("uuid");

var aws_amplify_1 = require("aws-amplify");

function upload(_x) {
  return _upload.apply(this, arguments);
}

function _upload() {
  _upload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file) {
    var expiryDate, name, key, result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (file) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            expiryDate = new Date();
            expiryDate.setHours(expiryDate.getHours() + 1);
            name = typeof file !== "string" ? file.name : "runtime";
            key = "".concat(name, "-").concat(uuid_1.v4());
            _context.next = 8;
            return aws_amplify_1.Storage.put(key, file, {
              level: 'private',
              contentType: 'application/json',
              expires: expiryDate
            });

          case 8:
            _context.next = 10;
            return aws_amplify_1.Storage.get(key, {
              level: 'private',
              expires: 60 * 60 //sec

            });

          case 10:
            result = _context.sent;
            console.log("Uploaded ".concat(name, " to"), result);
            return _context.abrupt("return", result);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _upload.apply(this, arguments);
}

exports.upload = upload;